// src/components/UI.jsx
// 재사용 공통 컴포넌트 모음

export const Chip =({ label, selected, onClick }) => (
  <button
    onClick={onClick}
    style={{
      padding: "10px 18px",
      borderRadius: 20,
      border: `1.5px solid ${selected ? "#c4845a" : "#ead6c0"}`,
      background: selected ? "#fff0e8" : "white",
      color: selected ? "#c4845a" : "#b09070",
      fontSize: 16,
      fontWeight: 400,
      cursor: "pointer",
      fontFamily: "'Gowun Batang', serif",
      transition: "all .2s",
    }}
  >
    {label}
  </button>
);

export const Input = ({ placeholder, value, onChange, style = {} }) => (
  <input
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    style={{
      width: "100%",
      padding: "14px 16px",
      border: "1.5px solid #ead6c0",
      borderRadius: 14,
      fontSize: 16,
      fontWeight: 400,
      fontFamily: "'Gowun Batang', serif",
      color: "#5c3d2e",
      background: "#fdf9f5",
      outline: "none",
      marginBottom: 12,
      ...style,
    }}
    onFocus={(e) => { e.target.style.borderColor = "#c4845a"; e.target.style.background = "white"; }}
    onBlur={(e) => { e.target.style.borderColor = "#ead6c0"; e.target.style.background = "#fdf9f5"; }}
  />
);

export const Textarea = ({ placeholder, value, onChange, style = {} }) => (
  <textarea
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    style={{
      width: "100%",
      padding: "14px 16px",
      border: "1.5px solid #ead6c0",
      borderRadius: 14,
      fontSize: 16,
      fontWeight: 400,
      fontFamily: "'Gowun Batang', serif",
      color: "#5c3d2e",
      background: "#fdf9f5",
      outline: "none",
      resize: "none",
      minHeight: 96,
      marginBottom: 12,
      ...style,
    }}
  />
);

export const BtnMain = ({ children, onClick, disabled }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    style={{
      width: "100%",
      padding: 16,
      borderRadius: 16,
      background: disabled
        ? "#e8d5c0"
        : "linear-gradient(135deg, #c4845a, #d4a070)",
      color: "white",
      fontSize: 16,
      fontWeight: 700,
      fontFamily: "'Jua', sans-serif",
      border: "none",
      cursor: disabled ? "not-allowed" : "pointer",
      boxShadow: disabled ? "none" : "0 4px 18px rgba(196,132,90,.35)",
      transition: "all .2s",
      marginTop: 10,
    }}
  >
    {children}
  </button>
);

export const BtnSub = ({ children, onClick }) => (
  <button
    onClick={onClick}
    style={{
      width: "100%",
      padding: 14,
      borderRadius: 16,
      background: "white",
      color: "#b09070",
      fontSize: 16,
      fontWeight: 400,
      fontFamily: "'Gowun Batang', serif",
      border: "1.5px solid #ead6c0",
      cursor: "pointer",
      transition: "all .2s",
      marginTop: 8,
    }}
  >
    {children}
  </button>
);

export const Card = ({ children, style = {}, stepKey }) => (
  <div
    key={stepKey}
    style={{
      background: "white",
      borderRadius: 24,
      padding: "36px 32px",
      boxShadow: "0 4px 24px rgba(92,61,46,0.07)",
      animation: "fadeUp .5s cubic-bezier(0.22, 1, 0.36, 1)",
      ...style,
    }}
  >
    {children}
  </div>
);

export const StepLabel = ({ children }) => (
  <div style={{ fontSize: 12, color: "#c4845a", letterSpacing: 2, fontFamily: "'Jua', sans-serif", marginBottom: 8 }}>
    {children}
  </div>
);

export const CardTitle = ({ children }) => (
  <div style={{ fontFamily: "'Jua', sans-serif", fontSize: 24, fontWeight: 700, color: "#5c3d2e", marginBottom: 8 }}>
    {children}
  </div>
);

export const CardDesc = ({ children, style = {} }) => (
  <div style={{ fontSize: 16, fontWeight: 400, color: "#b09070", lineHeight: 1.8, marginBottom: 24, ...style }}>
    {children}
  </div>
);

export const Divider = () => (
  <div style={{ height: 1, background: "#f0e4d8", margin: "20px 0" }} />
);

export const ProgressBar =({ total, current }) => (
  <div style={{ display: "flex", gap: 8, marginBottom: 36, justifyContent: "center" }}>
    {Array.from({ length: total }).map((_, i) => (
      <div
        key={i}
        style={{
          height: 8,
          width: i === current ? 28 : 8,
          borderRadius: i === current ? 4 : "50%",
          background: i === current ? "#c4845a" : i < current ? "#e8a878" : "#e8d5c0",
          transition: "all .3s",
        }}
      />
    ))}
  </div>
);

export const LoadingDots = () => (
  <div style={{ display: "flex", gap: 8, justifyContent: "center", marginTop: 20 }}>
    {[0, 1, 2].map((i) => (
      <div
        key={i}
        style={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          background: "#c4845a",
          animation: `pulse 1.2s ease-in-out ${i * 0.2}s infinite`,
        }}
      />
    ))}
  </div>
);
